import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M5.774 12.876c4.528 0 7.005-3.752 7.005-7.005 0-.107-.002-.213-.007-.318.48-.347.898-.781 1.228-1.275a4.928 4.928 0 01-1.414.388 2.473 2.473 0 001.083-1.362 4.946 4.946 0 01-1.563.598 2.462 2.462 0 00-4.195 2.245 6.993 6.993 0 01-5.076-2.572 2.46 2.46 0 00.763 3.286 2.437 2.437 0 01-1.116-.308l-.001.031c0 1.193.849 2.188 1.975 2.414a2.425 2.425 0 01-1.111.043 2.464 2.464 0 002.3 1.71A4.943 4.943 0 012 11.771a6.972 6.972 0 003.774 1.105"/>
		</svg>
	);
};
